export default "__VITE_ASSET__C0gHKJ3T__"